import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  mapMessage,
  MessagePosition,
  SnackBarService,
} from '@epicuro-next/ataraxia/snack-bar';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { Placement } from '@epicuro-next/utilities';
import { Product } from 'graphql-api/gql-api-interfaces';

const COPY_SUCCESS = $localize`:Pulse|Copy ID to clipboard success message@@copyIDToClipboardSuccess:ID copied`;
const COPY_FAILED = $localize`:Pulse|Copy ID to clipboard failed message@@copyIDToClipboardFailed:Failed to copy ID`;

const selector = 'atx-product-card-style-id';

@DynamicComponentRegister(selector, true)
@Component({
  selector,
  styleUrls: ['./product-card-style-id.component.scss'],
  templateUrl: './product-card-style-id.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardStyleIdComponent {
  public readonly copyIdText = $localize`:Pulse|Tooltip text for copy id icon@@copyIdIconTooltipText:Copy ID`;
  public readonly tooltipPlacement = Placement.TOP;

  @Input() public formattedProductId: string;
  @Input() public product: Product;
  @Input() public idFields: string[] = ['displayedProductId'];
  @Input() public showLabel = true;

  constructor(private readonly snackBarService: SnackBarService) {}

  public copiedToClipboard(success: boolean) {
    const messageData = mapMessage(success, COPY_SUCCESS, COPY_FAILED);
    this.snackBarService.show(
      messageData.msg,
      MessagePosition.BOTTOM,
      messageData.msgType,
    );
  }
}

DontTreeShake(ProductCardStyleIdComponent);
